export enum WarningEnum {
  MaxValueLimitedByValue,
  MinValueLimitedByValue,
  RequiredBoolean,
}
